import { withTheme } from '@material-ui/core/styles';
import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  box-shadow: 0 0.1rem 0.8rem 0 rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.4);
  background-color: ${({ disabled }) => (disabled ? '#eee' : '#fff')};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 1rem;

    border-bottom: 1px solid rgba(0, 0, 0, 0.4);

    color: ${({ disabled }) => (disabled ? '#7C7979' : '#3f51b5')};
    flex-shrink: 0;

    .title {
      display: flex;
      align-items: center;
      margin-right: 1.5rem;

      svg {
        font-size: 3.2rem;
        margin-right: 0.5rem;
      }

      h1 {
        font-size: 1.4rem;
        line-height: 1;
      }
    }

    @media (max-width: 768px) {
      padding: 0.75rem;

      .title {
        margin-right: 1rem;

        svg {
          font-size: 3rem;
        }

        h1 {
          font-size: 1.4rem;
        }
      }
    }
  }

  .card-content {
    flex: 1;
    padding: 1rem;
  }
`;

export const Paginacao = styled.div`
  font-size: 1.1rem;
  font-weight: bold;
  margin-left: 1rem;
  text-align: right;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const SemModuloWrapper = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7c7979;
  text-align: center;
  font-size: 1.4rem;
`;
